























import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import Icon from '@/components/Icon.vue';
import LoaderCircular from '@/components/LoaderCircular.vue';

@Component({
  components: {
    Icon,
    LoaderCircular,
  },
})
export default class ImagePreview extends Vue {
  @Prop() imageUrl: string;
  @Watch('imageUrl') imageUpdate() {
    if (this.invalid) {
      this.imageElementLoading = true;
    }
  }
  @Prop({ default: false }) invalid: boolean;

  imageElementLoading = false;

  get validImageUrl(): string {
    return this.invalid ? '' : this.imageUrl;
  }

  get showPreviewBox(): boolean {
    return this.imageElementLoading || this.imageUrl === '' || this.invalid;
  }

  get showImagePreview(): boolean {
    return this.imageUrl && !this.invalid && !this.imageElementLoading;
  }
}
